export const tel = {
  number: '+78006505000',
  label: '8(800)650-50-00'
};

export const coopyright = '2018';
